import {memo} from 'react';

import {HeaderAllowedFeatures} from '~/shared/components/header/types';

import PageHeaderDefault from './PageHeaderDefault';

type PageHeaderDefaultRouterProps = HeaderAllowedFeatures & {
  isHardLogoClick?: boolean;
  readOnlyAddress?: boolean;
  scrollTopOnOpenAddressDropdown?: boolean;
  isUserLoggedIn: boolean;
};

const PageHeaderDefaultRouter = (props: PageHeaderDefaultRouterProps) => <PageHeaderDefault {...props} />;

export default memo(PageHeaderDefaultRouter);
